export const verticalAlignBottomIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M1 19v-2h18v2zm9-2l-5-5 1.4-1.4L9 13.2V1h2v12.2l2.6-2.6L15 12z"/></svg>`,
  name: 'vertical-align-bottom',
};
